/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { StediPayer } from './StediPayer';
import {
    StediPayerFromJSON,
    StediPayerFromJSONTyped,
    StediPayerToJSON,
    StediPayerToJSONTyped,
} from './StediPayer';
import type { EligibilityRoutingReason } from './EligibilityRoutingReason';
import {
    EligibilityRoutingReasonFromJSON,
    EligibilityRoutingReasonFromJSONTyped,
    EligibilityRoutingReasonToJSON,
    EligibilityRoutingReasonToJSONTyped,
} from './EligibilityRoutingReason';
import type { ExacareEligibilityResponse } from './ExacareEligibilityResponse';
import {
    ExacareEligibilityResponseFromJSON,
    ExacareEligibilityResponseFromJSONTyped,
    ExacareEligibilityResponseToJSON,
    ExacareEligibilityResponseToJSONTyped,
} from './ExacareEligibilityResponse';
import type { EligibilityCheckRequestObject } from './EligibilityCheckRequestObject';
import {
    EligibilityCheckRequestObjectFromJSON,
    EligibilityCheckRequestObjectFromJSONTyped,
    EligibilityCheckRequestObjectToJSON,
    EligibilityCheckRequestObjectToJSONTyped,
} from './EligibilityCheckRequestObject';

/**
 * 
 * @export
 * @interface EligibilityCheck
 */
export interface EligibilityCheck {
    /**
     * 
     */
    check_id: string;
    /**
     * 
     */
    date_executed: Date;
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    user_name: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    request_object: EligibilityCheckRequestObject;
    /**
     * 
     */
    eligibility_view_model?: ExacareEligibilityResponse;
    /**
     * 
     */
    coverage_priority: string;
    /**
     * 
     */
    provider?: EligibilityCheckProviderEnum;
    /**
     * 
     */
    routing_reason?: EligibilityRoutingReason;
    /**
     * 
     */
    stedi_payer?: StediPayer;
    /**
     * 
     */
    member_identifier_type?: EligibilityCheckMemberIdentifierTypeEnum;
    /**
     * 
     */
    report_s3_key?: string;
    /**
     * 
     */
    pdf_generation_status?: EligibilityCheckPdfGenerationStatusEnum;
}


/**
 * @export
 */
export const EligibilityCheckProviderEnum = {
    Inovalon: 'inovalon',
    Stedi: 'stedi',
} as const;
export type EligibilityCheckProviderEnum = typeof EligibilityCheckProviderEnum[keyof typeof EligibilityCheckProviderEnum];

/**
 * @export
 */
export const EligibilityCheckMemberIdentifierTypeEnum = {
    Mbi: 'MBI',
    Ssn: 'SSN',
} as const;
export type EligibilityCheckMemberIdentifierTypeEnum = typeof EligibilityCheckMemberIdentifierTypeEnum[keyof typeof EligibilityCheckMemberIdentifierTypeEnum];

/**
 * @export
 */
export const EligibilityCheckPdfGenerationStatusEnum = {
    Pending: 'pending',
    Generated: 'generated',
    Failed: 'failed',
} as const;
export type EligibilityCheckPdfGenerationStatusEnum = typeof EligibilityCheckPdfGenerationStatusEnum[keyof typeof EligibilityCheckPdfGenerationStatusEnum];


/**
 * Check if a given object implements the EligibilityCheck interface.
 */
export function instanceOfEligibilityCheck(value: object): value is EligibilityCheck {
    if (!('check_id' in value) || value['check_id'] === undefined) return false;
    if (!('date_executed' in value) || value['date_executed'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('user_name' in value) || value['user_name'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('request_object' in value) || value['request_object'] === undefined) return false;
    if (!('coverage_priority' in value) || value['coverage_priority'] === undefined) return false;
    return true;
}

export function EligibilityCheckFromJSON(json: any): EligibilityCheck {
    return EligibilityCheckFromJSONTyped(json, false);
}

export function EligibilityCheckFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityCheck {
    if (json == null) {
        return json;
    }
    return {
        
        'check_id': json['check_id'],
        'date_executed': (json['date_executed'] == null ? json['date_executed'] : parseDateTime(json['date_executed'])),
        'user_id': json['user_id'],
        'user_name': json['user_name'],
        'lead_id': json['lead_id'],
        'request_object': EligibilityCheckRequestObjectFromJSON(json['request_object']),
        'eligibility_view_model': json['eligibility_view_model'] == null ? undefined : ExacareEligibilityResponseFromJSON(json['eligibility_view_model']),
        'coverage_priority': json['coverage_priority'],
        'provider': json['provider'] == null ? undefined : json['provider'],
        'routing_reason': json['routing_reason'] == null ? undefined : EligibilityRoutingReasonFromJSON(json['routing_reason']),
        'stedi_payer': json['stedi_payer'] == null ? undefined : StediPayerFromJSON(json['stedi_payer']),
        'member_identifier_type': json['member_identifier_type'] == null ? undefined : json['member_identifier_type'],
        'report_s3_key': json['report_s3_key'] == null ? undefined : json['report_s3_key'],
        'pdf_generation_status': json['pdf_generation_status'] == null ? undefined : json['pdf_generation_status'],
    };
}

export function EligibilityCheckToJSON(json: any): EligibilityCheck {
    return EligibilityCheckToJSONTyped(json, false);
}

export function EligibilityCheckToJSONTyped(value?: EligibilityCheck | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'check_id': value['check_id'],
        'date_executed': value['date_executed'] == null ? value['date_executed'] : serializeDateTime(value['date_executed']),
        'user_id': value['user_id'],
        'user_name': value['user_name'],
        'lead_id': value['lead_id'],
        'request_object': EligibilityCheckRequestObjectToJSON(value['request_object']),
        'eligibility_view_model': ExacareEligibilityResponseToJSON(value['eligibility_view_model']),
        'coverage_priority': value['coverage_priority'],
        'provider': value['provider'],
        'routing_reason': EligibilityRoutingReasonToJSON(value['routing_reason']),
        'stedi_payer': StediPayerToJSON(value['stedi_payer']),
        'member_identifier_type': value['member_identifier_type'],
        'report_s3_key': value['report_s3_key'],
        'pdf_generation_status': value['pdf_generation_status'],
    };
}

